

import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TiposService } from 'src/app/services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

import { ConsultaPagosConvenioService } from './../../services/consulta-pagos-convenio/consulta-pagos-convenio.service';

import { ModalInfoBeneficiario } from '../common/modal-info-beneficiario.component';
import { DialogValidarPagoConvenio } from './../convenio-abono/convenio-validar-pago.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';


@Component({
  selector: 'app-consulta-pagos-convenio',
  templateUrl: '../../pages/consulta-pagos-convenio/consulta-pagos-convenio.component.html',
  styleUrls: ['../../pages/consulta-pagos-convenio/consulta-pagos-convenio.component.css']//,
  //imports: [MatButtonModule, MatTooltipModule]
})
export class ConsultaPagosConvenioComponent implements OnInit 
{
    pagosPrestamo: any
    email:any
    postulacionesFinales: any
    postulacionSeleccionada: any
    allComplete: boolean = false
    rol: string = localStorage.getItem("rol")
    idUsuario: string= localStorage.getItem("idUsuario");
   // config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 5,  paginasTotal:5 }
    config: any = { itemsPerPage: 5, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 5,  paginasTotal: 5 }

    tipoPostulacion : string = "APROBADA"
    idEjecutivo = localStorage.getItem("idUsuario")
    solicitud: any
    data:any
    regiones: any
    estado:any
    buscador: any =
    {
        rut:'', region:'0', fechaInicio:'', fechaFin:'', itemsPerPage: 5, currentPage:1, idPlan:'',
        estado:['INGRESADA', ,'EN VALIDACION','RECHAZADA', 'APROBADA', 'PENDIENTE'],
        paginasTotal:5, estadoselect:['INGRESADA']
    }
    tipos:any
  

    constructor(public router: Router, 
      public consultaPagosConvenioService:ConsultaPagosConvenioService, 
                private dialog: MatDialog, private tiposService: TiposService) { }

    ngOnInit(): void
        { this.loadData() }
    
    loadData()
    {       
        let vm = this;
       
        
            this.consultaPagosConvenioService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error))

            this.consultaPagosConvenioService.traeEstados().then(estado=> this.estado = estado).catch(error => console.log(error))

            this.postulacionesDisponiblesBuscador(false);

    }

    postulacionesDisponiblesBuscador(recarga?:boolean){
        
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        
        vm.tipoPostulacion = "Disponibles"

        if(recarga) {
          vm.config.currentPage = 1, vm.buscador.currentPage = 1
          this.buscador.region = "0";
          this.buscador.estadoselect=['INGRESADA', 'PAGADA', 'DISPONIBLE PARA PAGO', 'RECHAZADA', 'APROBADA'];
          this.buscador.rut ='';
          this.buscador.fechaInicio='';
          this.buscador.fechaFin='';
          this.buscador.idSolicitud='';

        }
     
        this.buscador.estado=this.buscador.estadoselect;
        
          vm.consultaPagosConvenioService.pagosDisponiblesBuscador(this.idUsuario,this.rol,this.buscador,localStorage.getItem("username")).then(
            (planes : any)=>
             {
                planes.resultado.forEach(plan => { planes.seleccionado = false })
                vm.pagosPrestamo = planes.resultado

                vm.config.totalItems = planes.cantidadRegistros
                vm.pagosPrestamo = planes.resultado
               
                
                Swal.close();
               }
             )
           .catch ( error =>
           {
            console.log(error);
                       
            vm.config.currentPage = 1
            vm.pagosPrestamo = []            
            vm.config.totalItems = 0
          
               Swal.close();
               this.openAlertDialog('No se pudo obtener los pagos disponibles.', 'btn-danger')
           } )
    }

    postulacionesAsignadas(recargar?: boolean){
        
      this.tipoPostulacion  = "Asignadas"
   
      let vm = this
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
      vm.tipoPostulacion = "Asignadas"

      if(recargar){ this.config.currentPage = 1, this.buscador.currentPage = 1
        this.buscador.region = "0";
        this.buscador.estadoselect=['EN VALIDACION'];
        this.buscador.rut ='';
        this.buscador.fechaInicio='';
        this.buscador.fechaFin='';
        this.buscador.idSolicitud='';
    }
      this.buscador.estado=this.buscador.estadoselect;
      
      this.consultaPagosConvenioService.traePostulacionesAsignadas(this.idUsuario, this.buscador).then
      (
          (postulaciones: any) =>
          {
              console.log(postulaciones)

              vm.pagosPrestamo = postulaciones.resultado

              vm.config.totalItems = postulaciones.cantidadRegistros
              Swal.close();
          }
      )
      .catch ( error =>
      {
        console.log(error)
        vm.pagosPrestamo = [] 
                   
        vm.config.currentPage = 1
               
        vm.config.totalItems = 0
      
           Swal.close();
      } )
  }

  buscarOpcion(){
    this.buscador.itemsPerPage=this.config.itemsPerPage
    this.buscar()
  }
 

    buscar(){
      this.buscador.currentPage = 1, this.config.itemsPerPage = 5

        if( (this.buscador.fechaInicio != '' && this.buscador.fechaFin == '')
        || (this.buscador.fechaInicio == '' && this.buscador.fechaFin != ''))
        {
            this.openAlertDialog('Favor seleccionar fecha de inicio y fecha fin.', 'btn-danger')
            return
        }else{
          let fechaInicial = this.buscador.fechaInicio.split('-')
          let fechaFinal = this.buscador.fechaFin.split('-')
          if(this.buscador.estadoselect.length==0){
            this.openAlertDialog('Favor seleccionar al menos un estado.', 'btn-danger')
            return
          }

          if(parseInt(fechaInicial[0] + '' + fechaInicial[1] + '' + fechaInicial[2]) >parseInt(fechaFinal[0] + '' + fechaFinal[1] + '' + fechaFinal[2])){

            this.openAlertDialog('Favor la fecha de inicio es mayor a la final.', 'btn-danger');
            this.buscador.fechaFin="";
            return
          }
        }
    
        this.pagosDisponiblesBuscador(this.tipoPostulacion)
     
    }

    cambiaCantidadRegistros()
    {   
          this.config.indexInicial = 0, this.config.indexMaximo = this.config.itemsPerPage, this.config.currentPage = 1 
    }

    pagosDisponiblesBuscador(tipoPostulacion:any){
      let usuario= ''
      let vm = this;
      if(tipoPostulacion != 'Disponibles'){
        usuario= this.idUsuario;
      }
      this.buscador.estado=this.buscador.estadoselect;

      this.consultaPagosConvenioService.traePagosBuscador(usuario, this.buscador).then
      (
          (postulaciones: any) =>
          {
             
              vm.pagosPrestamo = postulaciones.resultado
              vm.buscador.paginasTotal = postulaciones.resultado.length
              vm.config.totalItems = postulaciones.cantidadRegistros
              vm.buscador.paginasTotal = postulaciones.cantidadPaginas
              this.buscador.paginasTotal = postulaciones.cantidadPaginas
              vm.config.currentPage = this.buscador.currentPage
              vm.config.totalItems = postulaciones.cantidadRegistros
              if (this.buscador.currentPage < postulaciones.cantidadPaginas && this.buscador.currentPage == 1) {
                this.config.itemsPerPage = postulaciones.resultado.length
              }
              
              Swal.close();
          }
      )
      .catch ( error =>
      {
        console.log(error)
        vm.pagosPrestamo = [] 
                  
        vm.config.currentPage = 1
              
        vm.config.totalItems = 0
      
          Swal.close();
      } )

    }
    openEditDialog(idPlanPago: any, nombreProducto: any, mostrarEditar?: any, disponiblePago?: any): void
    {
         this.openDialogValidarPago(idPlanPago, mostrarEditar,disponiblePago);
       
    }

    openDialogValidarPago(idPlanPago: any,  mostrarEditar?: any, disponiblePago?: any){
      this.consultaPagosConvenioService.buscarPago(idPlanPago).then(
        (response:any)=>{
          let fechaPagoAbono=''
          if(response.fechaAbono){
             fechaPagoAbono = response.fechaAbono.split('-')[2] + '-' + response.fechaAbono.split('-')[1] + '-' +
            response.fechaAbono.split('-')[0]
          }
      

          let data: any =
            {
              
                idConvenio: response.idConvenio,
                numCuota: response.numCuota,
                idPlanPago:response.idPlanPago,
                
                rutUsuario: response.rutUsuario,
                nombreUsuario : response.nombreUsuario,
                //fechaAbono: response.fechaAbono,
                fechaAbono: fechaPagoAbono,
                montoTotalCuota : response.montoTotalCuota,
                montoCuota: response.montoCuota,
                fechaPago:response.fechaPagoReal,
                fechaPagoIndicado :response.fechaPago,
                mostrarEditar:mostrarEditar,
                disponiblePago: disponiblePago
               
            }
            let vm =this;

            const dialogRef = vm.dialog.open(DialogValidarPagoConvenio,
                 { width: '40%', data: data} )
                 Swal.close();
            dialogRef.afterClosed().subscribe( () => {
       
              if(vm.tipoPostulacion=='Asignadas'){
                this.postulacionesAsignadas(false)
              }else{
                this.postulacionesDisponiblesBuscador(false)
              }
            
            } )
        }
      ).catch ( error =>
        {
            console.log(error)
              Swal.close();
            this.openAlertDialog('Ha ocurrido un error para visualizar el pago.', 'btn-danger')
        } )
    }

    verArchivo(postulacionId: any)
    {
        let vm = this
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        this.consultaPagosConvenioService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`             
                    window.open(fileURL);
                })  
               
            }
        )
        .catch ( error =>
        {
            console.log(error)
              Swal.close();
            vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
        } )
    }
    asignaPostulacion(idPostulacion: any)
    {
    console.log("idPostulacion o plan de pago a asignar!!!",idPostulacion)
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();
        let postulacion = [{idPlanPago:idPostulacion}]
        let vm = this

        this.consultaPagosConvenioService.asignaPostulacion(postulacion, this.idEjecutivo).then
        (
            () =>
            {
              if (vm.buscador.paginasTotal == 1 && vm.buscador.currentPage>1){

                vm.buscador.currentPage = vm.buscador.currentPage-1;
                  vm.config.currentPage = this.buscador.currentPage
              }
                vm.openAlertDialog('La solicitud de pago se ha asignado exitosamente.', 'btn-success')
                
                  vm.postulacionesDisponiblesBuscador(false)
                
                Swal.close();
            }
        )
        .catch
        (
            error =>
            {
                Swal.close();
                console.log(error)
                vm.openAlertDialog('La solicitud de pago no se ha podido asignar.', 'btn-danger')
            }
        )
    }
    asignarSeleccionados()
    {
        let postulacionesSeleccionadas: any = []

        this.pagosPrestamo.filter( pos => pos.seleccionado ).forEach(pos => {
            postulacionesSeleccionadas.push({idPlanPago:pos.idPlanPago })
        })

        let vm = this

        if(postulacionesSeleccionadas.length == 0)
        {
            this.openAlertDialog("Debe seleccionar al menos un pago.", "btn-danger")
            return
        }
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();

        this.consultaPagosConvenioService.asignaPostulacion(postulacionesSeleccionadas, this.idEjecutivo).then
        (
            () =>
            {
              if (vm.buscador.paginasTotal == postulacionesSeleccionadas.length && vm.buscador.currentPage>1){

                vm.buscador.currentPage = vm.buscador.currentPage-1;
                  vm.config.currentPage = this.buscador.currentPage
              }

                vm.openAlertDialog('La solicitudes de pago se han asignado exitosamente.', 'btn-success')

                this.postulacionesDisponiblesBuscador(false);


                  Swal.close();
            }
        )
        .catch ( error =>
        {
              Swal.close();
            console.log(error)
            vm.openAlertDialog('Las solicitudes de pago no se ha podido asignar.', 'btn-danger')
        } )
    }
    updateAllComplete()
    {
        this.allComplete =  this.pagosPrestamo != null && this.pagosPrestamo
                            .slice(this.config.indexInicial, this.config.indexMaximo)
                            .every(p => p.seleccionado)
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
  /*  
    pageChanged(event: any) {  this.config.currentPage = event 
      this.buscador.currentPage = event
      this.config.indexInicial = ( (this.config.currentPage - 1) * this.config.itemsPerPage)
      this.config.indexMaximo = ( this.config.currentPage * this.config.itemsPerPage )
      this.pagosDisponiblesBuscador(this.tipoPostulacion)
     }
*/

pageChanged(event: any) {
  this.config.currentPage = event, this.buscador.currentPage = event    
  if (this.tipoPostulacion == 'Disponibles') {
    console.log("dispo");
    this.postulacionesDisponiblesBuscador(false)
  }

  if (this.tipoPostulacion == 'Asignadas') {
    console.log("asig");
    this.postulacionesAsignadas(false)
  }
  

  this.config.indexInicial = ((this.config.currentPage - 1) * this.config.itemsPerPage)
  this.config.indexMaximo = (this.config.currentPage * this.config.itemsPerPage)

  //this.updateAllComplete()
}


    detalleBeneficiario(rutAfiliado: any)
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      Swal.showLoading();

        let data: any = { }

        this.consultaPagosConvenioService.traeUsuario(rutAfiliado.split('-')[0]).then
        (
            (usu: any) =>
            {
                console.log(usu)

                data.nombre = usu.nombres + ' ' + usu.apellidoPaterno + ' ' + usu.apellidoMaterno
                data.telefono = usu.telefonoFijo
                data.celular = usu.telefonoMovil
                data.mail = usu.email
                data.prevision = usu.prevision
                data.beneficiarios = usu.carga
            }
        )
        .catch(error => console.log(error))
        Swal.close();
        const dialogRef = this.dialog.open(ModalInfoBeneficiario, { width: '40%', data: data })

        dialogRef.afterClosed().subscribe( () => {  })
    }
}